// extracted by mini-css-extract-plugin
export default {"noAccess":"NoAccess_noAccess__aJHcc","noAccessTitle":"NoAccess_noAccessTitle__6qBMY","noAccessDescription":"NoAccess_noAccessDescription__4S1IM"};